import { Dialog, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Close } from '@mui/icons-material';
import { LongArrowSvg } from '../../../utility/CustomSvgIcons';

const _LabSampleHistoryPopup = ({ open, onClose, subPackageData, currDarkThemeClass, unitsMap, itemsMap }) => {
  const formatDate = dateString => {
    if (!dateString) return 'N/A';
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(new Date(dateString));
  };

  const isDarkTheme = Boolean(currDarkThemeClass);
  const labSamples = subPackageData?.subpackages || [];

  const styles = {
    dialog: {
      '& .MuiPaper-root': {
        backgroundColor: isDarkTheme ? '#1a1a1a' : '#ffffff',
        color: isDarkTheme ? '#e0e0e0' : '#333333',
      },
    },
    tableContainer: {
      backgroundColor: isDarkTheme ? 'rgba(158, 201, 107, 0.1)' : 'rgba(158, 201, 107, 0.05)',
      border: 'none',
      maxHeight: 400,
    },
    headerCell: {
      color: '#9ec96b',
      fontWeight: 500,
      fontSize: '0.9rem',
      borderBottom: isDarkTheme ? '1px solid rgba(158, 201, 107, 0.2)' : '1px solid rgba(158, 201, 107, 0.3)',
      backgroundColor: isDarkTheme ? 'rgba(158, 201, 107, 0.05)' : 'rgba(158, 201, 107, 0.1)',
    },
    cell: {
      color: isDarkTheme ? '#e0e0e0' : '#333333',
      borderBottom: isDarkTheme ? '1px solid rgba(158, 201, 107, 0.1)' : '1px solid rgba(158, 201, 107, 0.2)',
      padding: '12px 16px',
    },
    closeButton: {
      color: '#9ec96b',
    },
    dialogTitle: {
      padding: 0,
      marginLeft: 8,
      color: '#9ec96b',
      fontSize: '1.1rem',
    },
    tableRow: {
      '&:hover': {
        backgroundColor: isDarkTheme ? 'rgba(158, 201, 107, 0.05) !important' : 'rgba(158, 201, 107, 0.1) !important',
      },
    },
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth sx={styles.dialog}>
      <div style={{ padding: '16px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <DialogTitle sx={styles.dialogTitle}>
            Lab Sample Collection Details {subPackageData?.metrc_sub_package_tag_number && ` (${subPackageData.metrc_sub_package_tag_number})`}
          </DialogTitle>
          <IconButton onClick={onClose} size="small" sx={styles.closeButton}>
            <Close />
          </IconButton>
        </div>

        <TableContainer component={Paper} elevation={0} sx={styles.tableContainer}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={styles.headerCell}>Lab Sample Tag</TableCell>
                <TableCell sx={styles.headerCell}>Weight</TableCell>
                <TableCell sx={styles.headerCell}>Item</TableCell>
                <TableCell sx={styles.headerCell}>Note</TableCell>
                <TableCell sx={styles.headerCell}>Date</TableCell>
                <TableCell sx={styles.headerCell}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {labSamples.length > 0 ? (
                labSamples.map((item, index) => (
                  <TableRow key={`lab-sample-${index}-${item.id}`} hover sx={styles.tableRow}>
                    <TableCell sx={styles.cell}>{item.metrc_sub_package_tag_number || 'N/A'}</TableCell>
                    <TableCell sx={styles.cell}>
                      {item.current_sub_package_weight
                        ? `${parseFloat(item.current_sub_package_weight).toLocaleString()} ${
                            unitsMap[item.metrc_unit_of_measurement] === 'Kilograms' ? 'Kg' : 'g'
                          }`
                        : 'N/A'}
                    </TableCell>
                    <TableCell sx={styles.cell}>{itemsMap[item.item] || item.item || 'N/A'}</TableCell>
                    <TableCell sx={styles.cell}>{item.sub_package_note || 'N/A'}</TableCell>
                    <TableCell sx={styles.cell}>{formatDate(item.sub_package_date)}</TableCell>
                    <TableCell sx={styles.cell}>{item.current_sub_package_status || 'N/A'}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} sx={{ ...styles.cell, textAlign: 'center' }}>
                    No Lab Samples Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Dialog>
  );
};

export default _LabSampleHistoryPopup;
